export const apiDevUrl = 'https://api.slickcactus.com/dev';
export const localApiDevUrl = 'http://localhost:3001/dev';
export const timeZone = 'America/Chicago';
export const placeholderContactImg = 'https://files.spatialsearch.com/contact-photo.png';
export const placeholderCompanyImg = 'https://files.spatialsearch.com/business-logo.png';
export const placeholderPropertyImg = 'https://files.spatialsearch.com/property-photo.png';
export const placeholderListingImg = 'https://files.spatialsearch.com/property-photo.png';
